import React, { useState } from 'react';

import { WithSkeleton } from '@exchange-frontends/components';

export const AboutImage = ({ imageSRC, loading }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageErrored, setImageErrored] = useState(false);

  return (
    <div style={{ gridArea: 'image' }}>
      <picture>
        <source srcSet={imageSRC?.webp} type="image/webp" />
        <img
          src={imageSRC?.svg}
          alt=""
          style={imageLoaded ? { width: '100%' } : { display: 'none' }}
          onLoad={() => {
            setImageLoaded(true);
          }}
          onError={() => {
            setImageErrored(true);
          }}
        />
      </picture>
      {(loading || !imageLoaded || imageErrored) && (
        <WithSkeleton shouldRender={false} fullWidthContainer style={{ minHeight: '40vh' }}></WithSkeleton>
      )}
    </div>
  );
};
